var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWithdrawalLimit = function SvgWithdrawalLimit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#747481",
    d: "M3.506 3.503h21c.644 0 1.166.523 1.166 1.167v18.667c0 .644-.522 1.166-1.166 1.166h-21a1.167 1.167 0 0 1-1.167-1.166V4.67c0-.644.522-1.167 1.167-1.167m1.166 2.334V22.17H23.34V5.837zm5.834 7h2.333v2.333h-2.334v2.333H8.172V15.17H5.84v-2.334h2.333v-2.333h2.333zm4.666 0h7v2.333h-7z"
  })));
};
export default SvgWithdrawalLimit;